/**
 * Storage key + values for the "which main view did the user last use" flag.
 *
 * Lives in its own module because two features depend on the exact same key:
 * the Header (writes it on tab click, and redirects to Farm View on load when
 * it is set to Farm) and the global search (writes Field before sending the
 * user to the field view, so the Header redirect does not bounce them back).
 */

const VIEW_MODE_STORAGE_KEY = 'irrigation_monitoring_view_mode';

const VIEW_MODE = {
  FARM: 'Farm',
  FIELD: 'Field',
};

module.exports = { VIEW_MODE_STORAGE_KEY, VIEW_MODE };
